// extracted by mini-css-extract-plugin
export default {"inline":"hzt7yb","container":"BNnPeL","background":"_l4OEW","word":"JRCMb1","number":"Sqt_JX"};